// 血氧
<template>
  <div>
    <!-- <van-nav-bar
      v-if="$store.state.platform === 'ios'||$store.state.platform === 'android'"
      :title="$route.meta.title"
      left-arrow
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    /> -->
    <div>
      <van-tabs color="#F18937" @click="tabNav">
        <van-tab :title="$t('viewBase.a48')" name="0" />
        <van-tab :title="$t('viewBase.a49')" name="1" />
      </van-tabs>
      <div>
        <div class="sy-cell_center tag">
          <div @click="showStartDate=true">{{ first ? dateFormat(start, 'YYYY-MM-DD') : $t('viewBase.a50') }}</div>&nbsp;-&nbsp;
          <div @click="showEndDate=true">{{ first ? dateFormat(end, 'YYYY-MM-DD') : $t('viewBase.a51') }}</div>&nbsp;&nbsp;
          <van-icon name="arrow-down" />
        </div>
        <van-icon
          v-if="funcUrls==='bloodoxygen'||funcUrls==='bloodpressure'||funcUrls==='bloodsugar'"
          name="plus"
          class="addData"
          @click="handlePopup"
        />
      </div>
    </div>
    <div class="hd-text">{{ $t('viewBase.a52') }}</div>
    <div class="line-box">
      <EchartLine
        :data-x="dataX"
        :data-y="dataY"
        :newest="newest"
        :old="old"
        :type-date="listQuery.type"
        :tmp-server="tmp"
      />
      <div v-if="!tmp" class="sy-cell_center empty">{{ $t('viewBase.a47') }}</div>
    </div>
    <div class="hd-text">{{ $t('viewBase.a53') }}</div>
    <div class="table-box">
      <table v-if="newDetails||oldDetails" rules="all" width="100%" class="table-item">
        <tr>
          <th>{{ $t('viewBase.a54') }}</th>
          <th v-if="newDetails">{{ listQuery.type==='WEEK'?$t('viewBase.a55'):$t('viewBase.a56') }}</th>
          <th v-if="oldDetails">{{ listQuery.type==='WEEK'?$t('viewBase.a57'):$t('viewBase.a58') }}</th>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a50') }}</td>
          <td v-if="newDetails">{{ dateFormat(newDetails.startTime, 'MM-DD hh:mm') }}</td>
          <td v-if="oldDetails">{{ dateFormat(oldDetails.startTime, 'MM-DD hh:mm') }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a51') }}</td>
          <td v-if="newDetails">{{ dateFormat(newDetails.endTime, 'MM-DD hh:mm') }}</td>
          <td v-if="oldDetails">{{ dateFormat(oldDetails.endTime, 'MM-DD hh:mm') }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a59') }}）</td>
          <td v-if="newDetails">{{ newDetails.allCnt }}</td>
          <td v-if="oldDetails">{{ oldDetails.allCnt }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a60') }}</td>
          <td v-if="newDetails">{{ newDetails.ncnt }}</td>
          <td v-if="oldDetails">{{ oldDetails.ncnt }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a61') }}</td>
          <td v-if="newDetails">{{ newDetails.acnt }}</td>
          <td v-if="oldDetails">{{ oldDetails.acnt }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a62') }}</td>
          <td v-if="newDetails">{{ newDetails.avg }}</td>
          <td v-if="oldDetails">{{ oldDetails.avg }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a63') }}</td>
          <td v-if="newDetails">{{ newDetails.maxValue }}</td>
          <td v-if="oldDetails">{{ oldDetails.maxValue }}</td>
        </tr>
        <tr>
          <td>{{ $t('viewBase.a64') }}</td>
          <td v-if="newDetails">{{ newDetails.minValue }}</td>
          <td v-if="oldDetails">{{ oldDetails.minValue }}</td>
        </tr>
      </table>
      <EchartBar :newest="newestBar" :old="oldBar" :bar-list="barList" />
    </div>
    <!-- <div class="pla-msg">您的心脏健康指数综合分析，同上周情况对比健康指数有所提供，请继续保持。</div> -->
    <!-- start -->
    <van-datetime-picker
      v-show="showStartDate"
      v-model="start"
      :title="$t('viewBase.a50')"
      type="date"
      :max-date="end"
      cancel-button-text=" "
      @confirm="handleDateConfirm('start')"
    />
    <!-- end -->
    <van-datetime-picker
      v-show="showEndDate"
      v-model="end"
      :title="$t('viewBase.a51')"
      type="date"
      :max-date="maxDate"
      cancel-button-text=" "
      @confirm="handleDateConfirm('end')"
    />
    <van-popup v-model="showPopup" position="bottom" @close="showMeasureDate=false">
      <div class="popup-title">{{ $t('viewBase.a92') }}</div>
      <van-cell-group>
        <van-field
          v-if="funcUrls==='bloodoxygen'"
          v-model="dataForm.bo"
          clearable
          label="血氧"
          input-align="right"
          placeholder="请输入血氧"
        />
        <van-field
          v-if="funcUrls==='bloodpressure'"
          v-model="dataForm.sbp"
          clearable
          label="收缩压"
          input-align="right"
          placeholder="请输入收缩压"
        />
        <van-field
          v-if="funcUrls==='bloodpressure'"
          v-model="dataForm.dbp"
          clearable
          label="舒张压"
          input-align="right"
          placeholder="请输入舒张压"
        />
        <van-cell v-if="funcUrls==='bloodsugar'" title="测量时时段" class="bstime">
          <van-button
            size="small"
            :class="{ active: dataForm.bsTime == 'FPG'}"
            round
            plain
            hairline
            @click="dataForm.bsTime='FPG'"
          >餐前</van-button>
          <van-button
            size="small"
            :class="{ active: dataForm.bsTime == 'RANDOM'}"
            round
            plain
            hairline
            @click="dataForm.bsTime='RANDOM'"
          >餐后</van-button>
          <van-button
            size="small"
            :class="{ active: dataForm.bsTime == 'TWOHPPG'}"
            round
            plain
            hairline
            @click="dataForm.bsTime='TWOHPPG'"
          >随机</van-button>
        </van-cell>
        <van-field
          v-if="funcUrls==='bloodsugar'"
          v-model="dataForm.bs"
          clearable
          label="血糖"
          input-align="right"
          placeholder="请输入血糖"
        />
        <van-cell
          title="测量时间"
          :value="dataForm.measureDate ? dateFormat(dataForm.measureDate, 'YYYY-MM-DD hh:mm') : $t('viewBase.a72')"
          is-link
          @click="showMeasureDate=true"
        />
        <van-button type="info" class="btn" @click="submit">提交</van-button>
      </van-cell-group>
    </van-popup>

    <van-datetime-picker
      v-show="showMeasureDate"
      v-model="dataForm.measureDate"
      type="datetime"
      cancel-button-text=" "
      :max-date="maxDate"
      @confirm="handleMeasureDateConfirm"
    />
    <van-loading v-if="loading" type="spinner" color="#F19337" size="36px" vertical style="position:absolute;top:45%;left:45%;color:#F19337" />
  </div>
</template>

<script>
import { getAccountId, setAccountId } from '@/utils/auth'
import { dateFormat, dateISO } from '@/utils/tool'
import { GetQueryString } from '@/utils/wechat'
import { fetchMeasure, postBo } from '@/api/health'
import EchartLine from '../components/EchartLine'
import EchartBar from '../components/EchartBar'
export default {
  components: { EchartLine, EchartBar },
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      first: false,
      showMeasureDate: false,
      newDetails: null,
      oldDetails: null,
      newestBar: [],
      oldBar: [],
      dataX: [],
      dataY: [],
      newest: [],
      tmp: [],
      old: [],
      barList: [],
      datetime: new Date(),
      maxDate: new Date(),
      showPopup: false,
      dateFormat,
      showStartDate: false,
      showEndDate: false,
      start: date,
      end: new Date(),
      showDate: false,
      date: new Date(),
      currentDate: new Date(),
      tips: '',
      loading: true,
      finished: false,
      list: [],
      funcUrls: null,
      listQuery: {
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD hh:mm:ss')}`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD hh:mm:ss')}`),
        type: 'WEEK',
        accountId: getAccountId()
      },
      dataForm: {
        accountId: getAccountId() || 1,
        deviceCode: 'string',
        state: 'string',
        measureDate: new Date(),
        bsTime: 'FPG',
        bo: '',
        sbp: '',
        dbp: '',
        bs: ''
      }
    }
  },
  created() {
    console.log(this.$route.query.names)
    var names = this.$route.query.names
    if (!names) {
      names = GetQueryString('names')
    }
    document.title = names
    this.$route.meta.title = names
    console.log(names)
    var urls = this.$route.query.urls
    if (!urls) {
      urls = GetQueryString('urls')
    }
    this.funcUrls = urls
    // 家人的统计图
    if (this.$route.query.peopleAccountId > 0) {
      this.listQuery.accountId = this.$route.query.peopleAccountId
    }
    this.getList()
  },
  mounted() {
    // URL获取accountId直接进行存储
    var accountId = this.$route.query.accountId
    if (!accountId) {
      accountId = GetQueryString('accountId')
    }
    if (accountId) {
      setAccountId(accountId)
      // localStorage.setItem('GUIDERUSER.accountId', accountId)
    }
  },
  methods: {
    getList() {
      this.loading = true
      if (this.start) {
        this.listQuery.sTime = dateISO(
          `${dateFormat(this.start, 'YYYY/MM/DD')} 00:00:01`
        )
      }
      if (this.end) {
        this.listQuery.eTime = dateISO(
          `${dateFormat(this.end, 'YYYY/MM/DD')}  23:59:59`
        )
      }
      this.newest = []
      this.old = []
      this.newestBar = []
      this.oldBar = []
      this.tmp = []
      this.barList = []
      fetchMeasure(this.listQuery, this.funcUrls).then(res => {
        this.dataX = []
        if (res.data.data.newest) {
          if (res.data.data.newest.datas) {
            if (this.listQuery.type === 'WEEK') {
              this.classiFication(
                res.data.data.newest.datas,
                this.newest,
                this.$t('viewBase.a55'),
                'newest'
              )
            } else {
              this.classiFication(
                res.data.data.newest.datas,
                this.newest,
                this.$t('viewBase.a56'),
                'newest'
              )
            }
          }
          console.log(res.data.data)
          if (res.data.data.old !== null) {
            this.oldDetails = res.data.data.old.detail
          }
          this.newDetails = res.data.data.newest.detail
          this.classBar(res.data.data.newest.detail, this.newestBar, '/', 'newest')
        }
        if (res.data.data.old) {
          if (res.data.data.old.datas) {
            if (this.listQuery.type === 'WEEK') {
              this.classiFication(res.data.data.old.datas, this.old, this.$t('viewBase.a57'))
            } else {
              this.classiFication(res.data.data.old.datas, this.old, this.$t('viewBase.a58'))
            }
          }
          this.classBar(res.data.data.old.detail, this.oldBar, '/', 'old')
        }
        this.loading = false
      })
    },
    tabNav(name, title) {
      if (name === 0) {
        name = 'WEEK'
      } else {
        name = 'MONTH'
      }
      this.end = new Date()
      this.listQuery.type = name
      this.getList()
    },
    classiFication(event, target, targetName, targetname) {
      var field = this.$route.query.field
      if (!field) {
        field = GetQueryString('field')
      }
      console.log('URL获取参数field-->' + field)
      var types = field.split('&')
      var colorList = ['#F18937', '#37B2F1', '#E37FEF', '#98F7FD']
      types.forEach((itemChild, index) => {
        event.forEach((item, pIndex) => {
          if (targetname === 'newest' && index === 0) {
            this.dataX.push(dateFormat(item.testTime, 'M-D'))
          }
          if (types.length === 1) {
            target.push(item[types[index]])
            var datas = {
              name: targetName,
              type: 'line',
              symbol: 'circle',
              symbolSize: 8,
              smooth: true,
              lineStyle: {
                width: 2
              },
              data: target
            }
            if (pIndex === event.length - 1) {
              this.tmp.push(datas)
            }
          } else {
            target.push(item[types[index]])
            if (pIndex === event.length - 1) {
              datas = {
                name: types[index],
                type: 'line',
                symbol: 'circle',
                color:
                  targetname === 'newest'
                    ? colorList[index]
                    : colorList[types.length + index],
                symbolSize: 8,
                smooth: true,
                lineStyle: {
                  width: 2
                },
                data: target
              }
              this.tmp.push(datas)
              target = []
            }
          }
        })
      })
    },
    classBar(event, target, cutter, targetname) {
      var color = ['#37B2F1', '#F18937', '#98F7FD', '#E37FEF']
      if (event) {
        // if (event.avg.indexOf(cutter) !== -1) {
        var arr = event.avg.split(cutter)
        if (targetname === 'newest' && this.oldDetails.avg.split(cutter).length > arr.length) {
          arr.push('-')
        }
        if (targetname === 'old' && this.newDetails.avg.split(cutter).length > arr.length) {
          arr.push('-')
        }
        arr.forEach((item, index) => {
          target = []
          if (index === 0) {
            target.push(event.allCnt, event.ncnt, event.acnt, event.avg.split(cutter)[index], event.maxValue.split(cutter)[index], event.minValue.split(cutter)[index])
          } else {
            target.push('-', '-', 0, event.avg.split(cutter)[index], event.maxValue.split(cutter)[index], event.minValue.split(cutter)[index])
          }
          if (arr.length === 1 && targetname === 'old') {
            var colorSet = color[index]
          } else if (arr.length > 1 && targetname === 'old') {
            colorSet = color[arr.length + index]
          } else if (arr.length === 1 && targetname === 'newest') {
            colorSet = color[arr.length + index]
          } else if (arr.length > 1 && targetname === 'newest') {
            colorSet = color[index]
          }
          var dataBar = {
            name: 'ios',
            type: 'bar',
            stack: targetname,
            barCategoryGap: '0%',
            barWidth: '20%',
            barGap: 0,
            color: colorSet,
            data: target
          }
          this.barList.push(dataBar)
        })
      }
      // }
    },
    handleDateConfirm(e) {
      this.first = true
      this.showStartDate = false
      this.showEndDate = false
      this.listQuery.type = 'CUSTOM'
      this.getList()
    },
    handleMeasureDateConfirm() {
      this.showMeasureDate = false
      this.datetime = this.currentDate
    },
    handleMeasureDateCancel() {
      this.showMeasureDate = false
      this.dataForm.measureDate = this.datetime
    },
    handlePopup() {
      this.showPopup = true
    },
    submit() {
      this.dataForm.testTime = dateISO(this.dataForm.measureDate)
      postBo([this.dataForm]).then(res => {
        this.$toast('提交成功')
        this.showPopup = false
        this.showMeasureDate = false
        this.listQuery.page = 1
        this.currentDate = new Date()
        this.getList()
      })
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    //   Toast('返回')
    },
    onClickRight() {
    //   $this.Toast('按钮')
    }
  }
}
</script>

<style scoped lang="scss">
.item-hd {
  background: #fff;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addData {
  font-size: 18px;
}
.tag {
  width: 347px;
  height: 22px;
  background: rgba(224, 224, 224, 1);
  border-radius: 11px;
  margin: 13px auto;
}
.data {
  display: flex;
  justify-content: space-between;
  background: #fff;
  margin-top: 10px;
  padding: 12px 15px;
  .hd {
    color: #999;
  }
  .bd {
    color: #666;
    text-align: right;
  }
}
.van-picker {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}
.popup-title {
  text-align: center;
  padding: 10px;
  font-weight: bold;
}
.btn {
  width: 92%;
  margin: 30px 4% 20px;
}
.bstime {
  .van-cell__title {
    width: 150px;
    flex: none;
  }
  .van-cell__value {
    flex: auto;
  }
  .active {
    background: #f99600;
    color: #fff;
  }
}
.hd-text {
  font-size: 18px;
  margin: 0 0 9px 12px;
  font-weight: 600;
  color: rgba(23, 23, 23, 1);
}
.line-box {
  width: 347px;
  min-height: 165px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin: 0px auto 15px;
}
.table-box {
  width: 100%;
  height: auto;
  padding: 12px 14px;
  background: #fff;
  .table-item {
    margin-bottom: 20px;
    border-radius: 5px;
    border-collapse: separate;
    border-spacing: 0;
  }
  tr {
    height: 29px;
    border: 1px solid #e0e0e0;
  }
  tr:nth-of-type(1) {
    height: 34px;
    background: #fdead9;
  }
  td {
    text-align: center;
    color: #171717;
  }
  table tr:first-child th:first-child {
    border-top-left-radius: 5px;
    width: 30%;
  }

  table tr:first-child th:last-child {
    border-top-right-radius: 5px;
  }
  table tr:last-child td:first-child {
    border-bottom-left-radius: 5px;
  }

  table tr:last-child td:last-child {
    border-bottom-right-radius: 5px;
  }
}

.pla-msg {
  width: 100%;
  padding: 10px 14px;
  box-sizing: border-box;
  font-size: 10px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(125, 125, 125, 1);
  line-height: 21px;
}
</style>

<style lang="scss" scoped>
  .van-nav-bar{
    z-index:100!important;
  }
  .van-nav-bar .van-icon {
    color: #333;
    font-size: 20px;
  }
  .van-tabs_mar{
    margin-top: 40px;
  }
</style>
